import theme from '@segment/matcha/foundations/Theme'

import {
  BusinessIcon,
  CustomerSuccessIcon,
  EngagingIcon,
  CertificateIcon,
} from '@segment/matcha/components/Icons/Brandbook'

interface DatasheetBox {
  icon: React.ReactNode
  title: string
  description: string
  url: string
}

export const data: DatasheetBox[] = [
  {
    icon: <EngagingIcon color={theme.palette.neutrals.black[100]} />,
    title: `Jumpstart Lite`,
    description: `Self-paced learning and expert guidance to rapidly activate Segment capabilities and lay the foundation for your use cases.`,
    url: `https://assets.ctfassets.net/h6ufgtwb6nv1/1mhtgF0mBjz8WG2PCPTGGj/2cf25fbd76cd1796eeeb4245b3e38590/Jumpstart_Lite_Datasheet.pdf`,
  },
  {
    icon: <EngagingIcon color={theme.palette.neutrals.black[100]} />,
    title: `Twilio Engage Jumpstart`,
    description: `Strategic planning & implementation guidance to rapidly activate business-critical audiences in your downstream tools.`,
    url: `https://assets.ctfassets.net/h6ufgtwb6nv1/yldmZt4lmbFVF28P9NbsK/31df7daa4bf9da164fefccc27fb70184/Engage_Jumpstart_Datasheet.pdf`,
  },
  {
    icon: <EngagingIcon color={theme.palette.neutrals.black[100]} />,
    title: `Connections Jumpstart`,
    description: `Expert guidance and planning support to quickly send best-in-class, succinct & powerful data from your Sources to your Destinations.`,
    url: `https://assets.ctfassets.net/h6ufgtwb6nv1/WASOkw4EUuZVB3E36vQOU/e2faf38ee9c6f6815ef125b268dca872/Connections_Jumpstart_Datasheet.pdf`,
  },
  {
    icon: <EngagingIcon color={theme.palette.neutrals.black[100]} />,
    title: `Hybrid Jumpstart`,
    description: `Expert guidance and planning to quickly send best-in-class data from your Sources to Destinations and rapidly activate audiences in your downstream tools.`,
    url: `https://segment.com/pdfs/Twilio-Segment-Hybrid-Jumpstart-Datasheet.pdf`,
  },
  {
    icon: <CertificateIcon color={theme.palette.neutrals.black[100]} />,
    title: `Instructor-led Training`,
    description: `Expert-led, hands-on enablement designed to accelerate and upskill knowledge in Segment solutions.`,
    url: `https://assets.ctfassets.net/h6ufgtwb6nv1/4fWeIWNTvgRazvxoaopcL8/e2d02db81c2d47fc921d5dfbd55684de/Instructor-led_Training_Datasheet.pdf`,
  },
  {
    icon: <CertificateIcon color={theme.palette.neutrals.black[100]} />,
    title: `Implementation Certification`,
    description: `Upskill and validate knowledge in Segment solutions.`,
    url: `https://segment.com/pdfs/Twilio-Segment-Implementation-Certification-Datasheet.pdf`,
  },
  {
    icon: <BusinessIcon color={theme.palette.neutrals.black[100]} />,
    title: `Architecture Audit`,
    description: `A strategic assessment of your data flows, customer data pipelines and recommendations on how to make them cleaner, faster and more resilient.`,
    url: `https://assets.ctfassets.net/h6ufgtwb6nv1/1EVJJuuE298QKb6v11xEpf/5530f88e7104eb57f2b93e8fee1897f8/Architecture_Audit_Datasheet.pdf`,
  },
  {
    icon: <BusinessIcon color={theme.palette.neutrals.black[100]} />,
    title: `Schema Audit`,
    description: `A strategic assessment of your Segment schemas and recommendations on how to align them with best practices.`,
    url: `https://assets.ctfassets.net/h6ufgtwb6nv1/SaAhisvN2u4OIH4TgMQZ2/d868e9f15e7b8bdadc9ad7ff3b55fa39/Schema_Audit_Datasheet.pdf`,
  },
  {
    icon: <BusinessIcon color={theme.palette.neutrals.black[100]} />,
    title: `Health and Maturity Assessment`,
    description: `Assess your Segment workspace against our Customer Data Maturity and technical frameworks to uncover quick wins and long-term opportunities.`,
    url: `https://segment.com/pdfs/Twilio-Segment-Health-and-Maturity-Assessment-Datasheet.pdf`,
  },
  {
    icon: <BusinessIcon color={theme.palette.neutrals.black[100]} />,
    title: `Business Critical Services`,
    description: `Proactive strategic planning and dedicated ongoing enablement services.`,
    url: `https://segment.com/pdfs/Twilio-Segment-Business-Critical-Services-Datasheet.pdf`,
  },
  {
    icon: <CustomerSuccessIcon color={theme.palette.neutrals.black[100]} />,
    title: `Resident Architect`,
    description: `Dedicated, ongoing strategic planning & enablement support paced annually & customized to your specific needs.`,
    url: `https://assets.ctfassets.net/h6ufgtwb6nv1/EbbB03TdWRrNymxAX6WeS/aa4e442cd5c9c35d5325063e25dbf778/Resident_Architect_Datasheet.pdf`,
  },
  {
    icon: <CustomerSuccessIcon color={theme.palette.neutrals.black[100]} />,
    title: `Hourly Custom Coding`,
    description: `Sprint-based execution of development projects which extend Segment’s capabilities.`,
    url: `https://segment.com/pdfs/Twilio-Segment-Hourly-Custom-Coding-Datasheet.pdf`,
  },
  {
    icon: <CustomerSuccessIcon color={theme.palette.neutrals.black[100]} />,
    title: `Hourly Advisory Guidance`,
    description: `Focused guidance on specific Segment topics or troubleshooting questions, post implementation.`,
    url: `https://assets.ctfassets.net/h6ufgtwb6nv1/2tXzCUyp9GJKlRozr4hhBu/513830e6fff91e8a4ee9e7830e0af114/Hourly_Advisory_Guidance_Datasheet.pdf`,
  },
]
